import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormatDescriptionPipe } from './formatDrawDescription.pipe';

@NgModule({
  declarations: [FormatDescriptionPipe],
  imports: [CommonModule],
  exports: [FormatDescriptionPipe]
})
export class FormatDescriptionPipeModule { }
